import { Container, Typography, Paper,Box,Skeleton } from "@mui/material";
import dayjs from 'dayjs'
import { EmployeeFormValues, FormProviderWrapper } from "../components/employeeForm/formContext";
import { StepFormWrapper } from "../components/employeeForm/stepFormWrapper";
import { useEffect, useState } from "react";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import { useParams } from "react-router-dom";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";

const Employee = () => {
  const {id} = useParams();
  const {showMessage} = useSnackbar();

  const [loading,setLoading] = useState(false);
  const [initialData, setInitialData] = useState<any>(null);

  useEffect(() => {
  const fetchDataById = async () => {
    setLoading(true);
    try {
      const response: any = await callAPI(
        "employees/getBy",
        Method.GET,
        {},
        id
      );

      const employee = response?.employee;

      const normalizedData: Partial<EmployeeFormValues> = {
        ...employee,
         dob: employee?.dob ? dayjs(employee.dob).format('MM/DD/YYYY') : '',
  dateOfJoining: employee?.dateOfJoining ? dayjs(employee.dateOfJoining).format('MM/DD/YYYY') : '',
  confirmationDate: employee?.confirmationDate ? dayjs(employee.confirmationDate).format('MM/DD/YYYY') : '',

        // Optional: if your WSFileUpload component expects this shape
        profilePhoto: employee?.profilePhoto
          ? {
              name: employee.profilePhoto.split('/').pop(),
              url: employee.profilePhoto,
              type: "image"
            }
          : null,
        offerLetter: employee?.offerLetter
          ? {
              name: employee.offerLetter.split('/').pop(),
              url: employee.offerLetter,
              type: "pdf"
            }
          : null,
      };

      setInitialData(normalizedData);

    } catch (error: any) {
      console.error("Failed to retrieve employee data", error);
      if (error.message === 'GlobalHandledError') return;

      showMessage(
        error?.response?.data?.message || "Failed to retrieve data",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  if (id) fetchDataById();
}, [id]);


  console.log('initls are',initialData)

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        {id ? 'Edit Employee Profile' : 'Create Employee Profile'}
      </Typography>

      <Paper elevation={1} sx={{ padding: 3, marginTop: 2 }}>
        {loading ? (
          <Box>
            <Skeleton variant="text" width="60%" height={40} />
            <Skeleton variant="rectangular" height={80} sx={{ my: 2 }} />
            <Skeleton variant="rectangular" height={300} />
            <Skeleton variant="text" width="30%" sx={{ mt: 2 }} />
          </Box>
        ) : (
          <FormProviderWrapper initialData={initialData}>
            <StepFormWrapper id={id}/>
          </FormProviderWrapper>
        )}
      </Paper>
    </Container>
  );
};

export default Employee;
